import dayjs from 'dayjs'

export function getDefaultDateFilterTimestamps(): { toTimestamp: number; fromTimestamp: number } {
  return {
    fromTimestamp: dayjs().startOf('days').valueOf(),
    toTimestamp: dayjs().add(1, 'days').startOf('days').valueOf()
  }
}
